"use strict";
var constant = require("./constant.json");
var constantSystem = require("./constantSystem.json");
module.exports = {
    constant: constant,
    constantSystem: constantSystem
};
